import { render, staticRenderFns } from "./CustomersWizardStatus.vue?vue&type=template&id=478a8d7e&scoped=true"
import script from "./CustomersWizardStatus.vue?vue&type=script&lang=js"
export * from "./CustomersWizardStatus.vue?vue&type=script&lang=js"
import style0 from "./CustomersWizardStatus.vue?vue&type=style&index=0&id=478a8d7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478a8d7e",
  null
  
)

export default component.exports